/**
 * 生成画布id和元素id
 * @see https://github.com/dustinrouillard/snowflake-id
 */
import SnowflakeId from '@/util/snowflake'

const snowflake = new SnowflakeId({
  mid: 42,
  offset: (2023 - 1970) * 31536000 * 1000,
})

export default function generateId() {
  const snowflakeId = snowflake.generate()
  return snowflakeId
}
